import React from 'react';
import { useDispatch } from 'react-redux';
import { useVehicle } from '../../rcaSlice';
import Image from 'next/image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faChevronRight } from '@fortawesome/free-solid-svg-icons';
import styles from '../../../styles/rca/RCASearch.module.scss';
import { carPlateNumber } from '../../../utils/compare/rcaUtils';

const CarListItem = (props) => {
    const {id, car, editStep, setActiveVehicle} = props;
    const dispatch = useDispatch();

    const plateNumber = car.tip_inmatriculare.value == 'inmatriculat' && car.nr_inmatriculare  ? carPlateNumber(car.nr_inmatriculare) : car.serie_sasiu;

    const model = car.hasOwnProperty('model_auto') && car.model_auto;
    const marca = car.hasOwnProperty('marca_auto') && car.marca_auto && car.marca_auto.denumire;

    const goToCarDetails = () => {
        const payload = { serie_sasiu: car.serie_sasiu, step: 'car-info', status: 'save'};
        dispatch(useVehicle( payload ));
        setActiveVehicle(id);
        editStep('car-info');
    }

    return (
        <Col xs={12} md={4}  className={'p-3'}>
            <Card className={`${styles.carItem}`} >
                <Card.Body>
                    <Image src="/images/icons/leasing-auto.png" alt="Autovehicul nou" width={100} height={60} />
                    <p className={styles.model}>{marca} {model}</p>
                    <p className="mb-0">{plateNumber}</p>
                </Card.Body>
                <Card.Footer className="bg-white border-0 pt-0">
                    <Button className="w-100" onClick={goToCarDetails}>
                        Continuă
                        <FontAwesomeIcon icon={faChevronRight} className="ms-2" width="16" height="16"/>
                    </Button>
                </Card.Footer>
            </Card>
        </Col>
    );
}

export default CarListItem;